import React from 'react'
import { useForm } from 'react-hook-form'
import { Form } from 'react-bootstrap'
import { Button } from 'reactstrap'
import { message } from 'antd'
import styled from 'styled-components'

import QuestionForm from './QuestionForm'
import { storeQuestion } from '../services'
import { handleError } from '../../../helpers'

export default function NewQuestionForm({ survey, reload }) {
	const { register, handleSubmit, formState: { errors }, reset } = useForm()
	
	const onSubmit = values => {
		values.survey_id = survey.id
		console.log(values)
		storeQuestion(values)
			.then(()=>{
				message.success('Pregunta creada exitosamente')
				reset()
				reload()
			})
			.catch(error => handleError(error))
	}

	return (
		<Container>
			<Form onSubmit={handleSubmit(onSubmit)}>
				<QuestionForm register={register} errors={errors} />
				<Button type="submit" color="primary">Agregar Pregunta</Button>
			</Form>
		</Container>
	)
}

const Container = styled.div`
	background-color: #f8f8f8;
	padding: 20px;	
	max-width: 500px;
	margin: 20px auto 0px;
`